"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'autocomplete',
    'autofocus',
    'disabled',
    'form',
    'multiple',
    'name',
    'required',
    'size',
    'value',
]);
//# sourceMappingURL=select.js.map